import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// eslint-disable-next-line import/no-cycle
import SiteContext from "components/SiteContext";
import { componentClassName as buttonClassName } from "components/templatesComponents/Button";
import { componentClassName as linkClassName } from "components/templatesComponents/Link";
import { componentClassName as textClassName } from "components/templatesComponents/Text";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import { normalized } from "utils/urlUtils";

export const DSFRStep = (props) => {
  const { index = "", title = "", detail = "" } = props;

  const site = useContext(SiteContext);
  const { name: siteName } = site;

  const siteColor = useMemo(() => {
    switch (siteName) {
      case "IMMAT":
      case "PHA":
        return "var(--orange-terre-battue-main-645)";
      case "PERMIS":
      case "AUTO_ECOLE":
        return "var(--purple-glycine-main-494)";
      case "PASSEPORT_CNI":
      case "MAIRIE":
        return "var(--green-archipel-main-557)";
      default:
        return "info";
    }
  }, [siteName]);

  return (
    <Box
      id={`${index}-${normalized(title)}`}
      sx={{
        border: "1px solid var(--border-default-grey)",
        p: 2,
        pt: { xs: 3, lg: 4 },
      }}
    >
      <Grid container sx={{ alignItems: "center", mb: 1 }}>
        <Grid
          container
          component="span"
          sx={{
            alignItems: "center",
            justifyContent: "center",
            height: 32,
            width: 32,
            bgcolor: siteColor,
            color: "white",
            borderRadius: "50%",
            fontSize: "1.875rem",
            lineHeight: "100%",
            alignSelf: "start",
          }}
        >
          <Box
            component="span"
            sx={{
              fontSize: "20px",
              lineHeight: "30px",
              fontWeight: 900,
            }}
          >
            {index}
          </Box>
        </Grid>
        <Box
          component="h4"
          sx={{
            display: "flex",
            ml: 2,
            mb: 0,
            flex: "1 1 0px",
            color: "var(--text-title-grey)",
            fontSize: "1.5rem",
            fontWeight: 700,
          }}
        >
          {title}
        </Box>
      </Grid>
      {detail && (
        <Box
          sx={(theme) => ({
            minHeight: 50,
            "& > *": {
              mb: 2,
            },
            "& p.Da-Text:not(.fr-highlight)": {
              p: 0,
            },
            [`& > .${textClassName}`]: {
              px: { xs: 2, lg: 3 },
            },
            [`& > .${buttonClassName}, & > .${linkClassName} > .${buttonClassName}`]: {
              width: "100%",
            },
            "& .MuiExpansionPanelSummary-expandIcon": {
              p: { xs: 2, lg: 2.5 },
              color: theme.palette.getContrastText(theme.palette.secondary[30]),
            },
            "& .MuiExpansionPanel-root.Mui-expanded": {
              m: 0,
            },
            "& .MuiExpansionPanelSummary-root": {
              bgcolor: "secondary.30",
              color: theme.palette.getContrastText(theme.palette.secondary[30]),
            },
          })}
        >
          {detail}
        </Box>
      )}
    </Box>
  );
};

DSFRStep.propTypes = {
  index: PropTypes.number,
  title: PropTypes.string,
  detail: PropTypes.node,
};

const DSFRStepper = (props) => {
  const site = useContext(SiteContext);
  const { name: siteName } = site;

  const siteColor = useMemo(() => {
    switch (siteName) {
      case "IMMAT":
      case "PHA":
        return "var(--orange-terre-battue-main-645)";
      case "PERMIS":
      case "AUTO_ECOLE":
        return "var(--purple-glycine-main-494)";
      case "PASSEPORT_CNI":
      case "MAIRIE":
        return "var(--green-archipel-main-557)";
      default:
        return "info";
    }
  }, [siteName]);

  let { steps = [] } = props;
  if (steps && !Array.isArray(steps)) {
    steps = [steps];
  }

  return steps.map((step, index) => (
    <li key={step.props.id} className="stepperli">
      <step.type {...step.props} index={index + 1} />
      {index + 1 !== steps.length && (
        <Box sx={{ height: "50px", borderLeft: "2px solid", borderColor: siteColor, ml: { xs: 3.125, lg: 5 } }} />
      )}
    </li>
  ));
};

DSFRStepper.propTypes = {
  steps: PropTypes.node,
};

export default DSFRStepper;
